import { useEffect } from 'react';

function useIframeHeight(targetOrigin: string) {
    useEffect(() => {
        // Function to calculate and send the height to the parent
        const sendHeight = () => {
            // Use document.documentElement.scrollHeight for overall height
            const height = (document.body.scrollHeight || 200) + 10;
            window.parent.postMessage({ type: 'setHeight', height }, targetOrigin);
        };

        // Send initial height on mount
        sendHeight();

        // Create a MutationObserver to monitor DOM changes that might affect height
        const observer = new MutationObserver(() => {
            sendHeight();
        });

        // Observe changes in the body
        observer.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
        });

        // Also listen for window resize events, which might affect layout
        window.addEventListener('resize', sendHeight);

        sendHeight();

        // Cleanup: disconnect the observer and remove event listener when unmounting
        return () => {
            observer.disconnect();
            window.removeEventListener('resize', sendHeight);
        };
    }, [targetOrigin]);
}

export default useIframeHeight;
